exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#shop-summary .event-group {\n  margin-bottom: 5px;\n}\n#shop-summary .order-total {\n  text-align: right;\n  margin-right: 20px;\n}\n#shop-summary .ticket-price {\n  float: right;\n  padding-right: 20px;\n}\n#shop-summary .ticket-name {\n  max-width: 75%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n#shop-summary .product-price {\n  float: right;\n}\n#shop-summary .transaction-cost {\n  color: #999;\n  font-size: 0.8em;\n}\n#shop-summary .checkbox-label a {\n  color: #fdead6;\n  font-weight: bold;\n}\n", ""]);

// exports
